<template lang="pug">
  vm-prompt(vm-size="small" @vm-cancel="close" @vm-accept="print" @vm-close="close" :vm-accept-text="$t('strings.accept')" :vm-cancel-text="$t('strings.cancel')" :vm-is-valid="!$v.form.$invalid " :vm-active="isModalProspectReportsVisible" :vm-title='getTitle')
    vm-row(vm-align="center" vm-type="flex" vm-justify="space-between" vm-w="12" v-shortcuts="[{ shortcut: [ 'enter', ], callback: print, push: true, focus: true, disabled: $v.form.$invalid },]")
      vm-col(vm-justify="center", vm-align="center", vm-w=12)
        b-form-group
          vm-select(url="users" column="name" autocomplete :placeholder='$t("customers.seller_to_placeholder")' v-model="form.id" :label='$t("customers.filter_seller")' @input-change="autoCompleteFunc")
            vm-select-item(:key="index" :value="item.id" :text="item.name" v-for="(item,index) in customersCatalog.users")
        b-form-group
          vm-date-picker.data_class(type="daterange" :label="$t('customers.created_at')" :placeholder="$t('strings.select_date')" @on-change="handleChange" v-model="form.betweenDates")

</template>

<script>
import { required } from 'vuelidate/lib/validators'
import { createNamespacedHelpers } from 'vuex'
const { mapGetters, mapActions } = createNamespacedHelpers('Customers')

export default {
  name: 'ModalProspectReports',
  data: () => ({
    form: {}
  }),
  validations: {
    form: {
      id: {
        required
      },
      betweenDates: {
        required
      }
    }
  },
  computed: {
    ...mapGetters([
      'isModalProspectReportsVisible',
      'customersCatalog'
    ]),
    getTitle () {
      return this.$t('customers.prospect_reports')
    }
  },
  async created () {
    this.getCatalog()
  },
  methods: {
    ...mapActions([
      'loadCatalog',
      'printProspectReport',
      'setModalProspectReports'
    ]),
    async getCatalog () {
      Object.keys(this.customersCatalog).forEach(e => this.loadCatalog({ url: e, filter: '' }))
    },
    autoCompleteFunc (value) {
      let payload = {}
      let column = value.target.parentElement.parentElement.getAttribute('column')
      let param = value.srcElement.value
      payload.url = value.target.parentElement.parentElement.getAttribute('url')
      payload.filter = `?${column}=*${param}*&order_by=${column},asc`
      this.loadCatalog(payload)
    },
    handleChange (date) {
      this.form.betweenDates = date
    },
    print () {
      this.printProspectReport(this.form)
    },
    close () {
      this.form = {}
      this.setModalProspectReports(false)
    }
  }
}
</script>

<style>
.vm-select--options {
  z-index: 400331 !important;
}
.vm-col{
  padding: 0px 10px;
}
.btn_download {
  width: 100%;
}
.data_class {
  width: 100%;
}
</style>
